import { Component, Input, OnInit } from '@angular/core';
import { ROUTES } from './navbar-routes.config';
import { RouteInfo } from './../../_models/route-info.info';
import { User } from 'src/app/_models';
import { Role } from '../../_models/role';
import { MessService } from 'src/app/_services/mess-service.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  expand: boolean = false;
  menuItems: RouteInfo[] = [];
  currentUser: User;
  public roles = Role;
  currentUserRole: string;

  constructor(private menuToggle: MessService) {}

  ngOnInit(): void {
    this.menuItems = ROUTES.filter((menuItem) => menuItem);

    // Check current user role to show/hide menu items
    this.currentUser = JSON.parse(localStorage.getItem('user'));
    this.currentUserRole = Object.keys(this.roles)[
      Object.values(this.roles).indexOf(this.currentUser.user.role_id)
    ];
  }

  collapseMenu() {
    this.expand = !this.expand;
    this.menuToggle.changeState(this.expand);
  }

  toggleDropdown(menuItem: any, index: number) {
    this.menuItems.forEach((item: any, i) => {
      if (index !== i) {
        item.opened = false;
      }
    });
    this.menuItems[index].opened = !menuItem.opened;
  }
}
